import * as SwitchPrimitive from '@radix-ui/react-switch';
import type * as React from 'react';

import { cn, focusRing } from '@/lib/utils';

export function Switch({ className, ...props }: React.ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      className={cn(
        'peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors',
        focusRing,
        'disabled:cursor-not-allowed disabled:opacity-50',
        'data-[state=checked]:bg-primary data-[state=unchecked]:bg-secondary',
        className,
      )}
      {...props}
    >
      {/* As in the design system's toggle: a light knob when off, an ink one on
          the lime track when on. */}
      <SwitchPrimitive.Thumb
        className={cn(
          'pointer-events-none block size-4 rounded-full shadow-xs ring-0 transition-transform',
          'data-[state=checked]:translate-x-4 data-[state=checked]:bg-primary-foreground',
          'data-[state=unchecked]:translate-x-0 data-[state=unchecked]:bg-control-thumb',
        )}
      />
    </SwitchPrimitive.Root>
  );
}
